<template>
  <div class="panel-body">
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th>{{$t('words.options')}}</th>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Telefone</th>
              <th>Plano</th>
              <th>Confirmado?</th>
              <th>Cadastrado em</th>
              <th>Confirmado em</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" @click="sendMail(item.id)">
                      <i class="fa fa-send" aria-hidden="true"></i>
                      Reenviar e-mail
                    </a>                  
                    <a class="dropdown-item" @click="deleteData(item.id, item.email, 'pre-cadastro')">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      {{$t('words.delete')}}
                    </a>                  
                </div>
              </div>
            </td>
            <td>{{item.nome}}</td>
            <td>{{item.email}}</td>
            <td>{{item.telefone}}</td>
            <td><span v-if="item.plano">{{item.plano.plano_nome}}</span></td>
            <td>
              <span v-if="item.status" class="text-green"><i class="fa fa-check-circle"></i> Sim</span>
              <span v-else class="text-red"><i class="fa fa-times-circle"></i> Não</span>
            </td>
            <td>{{formatDate(item.created_at)}}</td>
            <td><span v-if="item.status">{{formatDate(item.updated_at)}}</span></td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterable: {
          deleted: false,
          model: 'preCadastro',
          options: 'municipios',
          storeAction: 'setPreCadastro',
          storeName: 'preCadastro.data',
          url: '/api/pre-cadastros',
          loading: false,
        },
        objectDetails: {},
        description: 'modulo',
        headers: {
          'Modulo': 'modulo',
        }
      };
    },
    beforeMount() {
     
     
      
      
     
      
    },
    computed: {
      planosModulo() {
        return this.$store.state.planoModulo.data;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'preCadastro') {
          this.prepareComponent();
        }
      }
    },
    methods: {
      sendMail(id) {
        this.filterable.loading = true;
        this.$store.dispatch('resendMailPreCadastro', id).then(response => {
          this.filterable.loading = false;
          toastr({
            title: response.message,
            icon: response.status
          });
        })
      }
    }
  };
</script>